define(["dojo/_base/declare", "dojo/_base/lang", "csi", "csi/def", "csi/def/Field", "csi/def/Relationship", "csi/form/Widget", "csi/xml", "csi/xml/Query"], function(declare, lang, csi, def, Field, Relationship, FormWidget, xml, Query) {

	return declare(FormWidget, {

		_resolveView: function() {
			var parentView_id = this.viewParent ? this.viewParent.defView.m_id : null;
			var viewNode = this.getViewNode();
			if (parentView_id == "NewPOFromSOWizard" || (viewNode && viewNode.POSalesOrder != csi.EMPTY_URL)) {
				var style = this.defView.m_formData ? this.defView.m_formData.m_parentNode : null;
				// if this is an action on style, only show sales orders for this style
				// otherwise, show all sales orders
				var filterQuery = new Query().Attr("IsReleased", xml.OP_EQUALS, "true");

				if (style && style.$Type == "Style") {
					filterQuery.RefAttr("SOStyles", xml.OP_EQUALS, style.$URL);
				}

				this.defView.addField(lang.mixin(new Field(), {
					m_id: "POSalesOrder",
					m_bRequired: true,
					m_typeControl: def.FIELD_FILTERING_SELECT,
					m_relationship: lang.mixin(new Relationship(), {
						m_typeNode: "SalesOrder",
						m_query: filterQuery
					})
				}));
			} else {
				this.defView.addField(lang.mixin(new Field(), {
					m_id: "OrdersByColor"
				}));
			}

			this.inherited(arguments);
		}
	});
});